<svelte:options
	customElement={{
		tag: 'rf-observer-trigger',
		shadow: 'open', // shadow: 'open'
	}}
/>

<script module>
	type ReframeObserverTriggerProps = {
		rootMargin?: number;
		triggerPosition?: number;
		layoutId?: string;
		debug?: boolean;
		direction?: 1 | -1;
		'go-to-target'?: string;
		'go-fullscreen'?: boolean;
		'zoom-in'?: boolean;
		'zoom-out'?: boolean;
		'go-home'?: boolean;
		'trigger-type'?: 'enter' | 'leave' | undefined;
		'trigger-direction'?: 'top' | 'bottom' | 'both';
	};
</script>

<script lang="ts">
	/**
	 * Import
	 */
	import cssVariables from '@src/utils/cssvariables';
	import { onMount, createEventDispatcher } from 'svelte';
	import { get } from 'svelte/store';
	import { useTriggerObserver } from '@core/rf-observer/useTriggerObserver';

	/**
	 * Props
	 */
	const {
		rootMargin,
		triggerPosition,
		layoutId,
		debug,
		'go-to-target': goToTarget,
		'go-fullscreen': goFullscreen,
		'zoom-in': zoomIn,
		'zoom-out': zoomOut,
		'go-home': goHome,
		'trigger-type': triggerType,
		'trigger-direction': triggerDirection,
	}: ReframeObserverTriggerProps = $props();

	/**
	 * composables
	 */
	const dispatch = createEventDispatcher();
	const { element } = useTriggerObserver({
		shouldObserve: typeof triggerPosition === 'number',
		debug,
		layoutId,
		rootMargin,
		triggerDirection,
		zoomIn,
		zoomOut,
		goHome,
		goToTarget,
		goFullscreen,
		triggerType,
	});
	/**
	 * Lifecycle
	 */
	onMount(() => {
		const currentElement = get(element);
		if (!currentElement) return;

		// typescript is not happy without the event forwarding
		currentElement.addEventListener('enter', ((e: Event) => {
			dispatch('enter', (e as CustomEvent).detail);
		}) as EventListener);

		currentElement.addEventListener('leave', ((e: Event) => {
			dispatch('leave', (e as CustomEvent).detail);
		}) as EventListener);
	});
</script>

<div
	part="rf-observer-trigger"
	class="rf-observer-trigger"
	style={cssVariables({
		'--marker-position': typeof triggerPosition === 'number' ? triggerPosition : 0,
		'--visibility': debug ? 'visible' : 'hidden',
	})}
	bind:this={$element}
></div>

<style lang="scss" global>
	.rf-observer-trigger {
		position: absolute;
		top: calc(var(--marker-position) * 100%);
		left: 0;
		width: 100%;
		height: 1px;
		background: red;
		pointer-events: none;
		visibility: var(--visibility);
	}
</style>
